import React from 'react';
import { keyframes, styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import type { Group } from '../../../common/types';
import useGetTicketTypesByGroup from '../../../controllers/get-ticket-types-by-group/index.tsx';
import useTicketTypesResource from '../../../controllers/ticket-types-resource/index.tsx';
import messages from './messages';

type Props = {
	groupId: Group['id'];
};

const CountLabel = ({ groupId }: Props) => {
	const { formatMessage } = useIntl();
	const [, loading] = useTicketTypesResource();
	const ticketTypes = useGetTicketTypesByGroup(groupId);

	return loading ? (
		<LoadingBar />
	) : (
		<Label>
			{formatMessage(messages.countLabel, { count: ticketTypes ? ticketTypes.length : 0 })}
		</Label>
	);
};

export default CountLabel;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Label = styled.div({
	font: token('font.body.UNSAFE_small'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.N300),
});

const loadingAnimation = keyframes({
	'0%': {
		backgroundPosition: '0 0',
	},
	'100%': {
		backgroundPosition: '-200% 0',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LoadingBar = styled.div({
	animation: `${loadingAnimation} 1s linear infinite`,
	background: `repeating-linear-gradient(
        to right,
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        ${token('color.skeleton', colors.N30)} 0%,
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        ${token('color.skeleton.subtle', colors.N10)} 50%,
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        ${token('color.skeleton', colors.N30)} 70%,
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        ${token('color.skeleton', colors.N30)} 100%
    )`,
	backgroundSize: '200% auto',
	backgroundPosition: '0 100%',
	animationFillMode: 'forwards',
	borderRadius: '3px',
	height: '17px',
	width: '25%',
});
